import { EntityThumbSquare } from "@/components/workspace/entity-thumb-square"
import { characterListThumbnail, type CharacterThumbnailSource } from "@/lib/character-thumbnail"

type Props = CharacterThumbnailSource & {
  name: string
  size?: "strip" | "overview" | "compact" | "radio"
  busy?: boolean
  busyLabel?: string
  emptyLabel?: string
  className?: string
}

export function CharacterPortraitSquare({
  name,
  size = "strip",
  busy,
  busyLabel,
  emptyLabel,
  className,
  ...source
}: Props) {
  return (
    <EntityThumbSquare
      name={name}
      imageUrl={characterListThumbnail(source)}
      size={size}
      busy={busy}
      busyLabel={busyLabel}
      emptyLabel={emptyLabel}
      className={className}
    />
  )
}
